import { render, staticRenderFns } from "./TabletHero.vue?vue&type=template&id=ce04ff9e&scoped=true"
import script from "./TabletHero.vue?vue&type=script&lang=js"
export * from "./TabletHero.vue?vue&type=script&lang=js"
import style0 from "./TabletHero.vue?vue&type=style&index=0&id=ce04ff9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce04ff9e",
  null
  
)

export default component.exports